













































































































































































































import Vue, { PropType } from "vue";
import { ProductDeliveryAddressInterface } from "@/model/components/ProductDeliveryAddressInterface";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { tel, zipcode } from "@/model/validators";
import { zenkakuToHankaku } from "@/model/replacer/zenkakuToHankaku";
import YubinBango from "yubinbango.js";
import {
  DeliveryAddressStringInterface,
  MANUSCRIPT_DELIVERY_ADDRESS
} from "@/model/delivery";
import {
  otherContactAresShow,
  storeContactAresShow
} from "@/model/views/display";

export default Vue.extend({
  name: "ProductDeliveryAddress",

  mixins: [validationMixin],

  props: {
    productDeliveryAddress: {
      type: Object as PropType<ProductDeliveryAddressInterface>,
      required: true
    },
    descriptionName: { type: String, default: "" },
    descriptionCompany: { type: String, default: "" },
    descriptionZipcode: { type: String, default: "" },
    descriptionAddress: { type: String, default: "" },
    descriptionTel: { type: String, default: "" }
  },

  validations() {
    let validations = {
      deliveryAddress: { required },
      name: {},
      company: {},
      zipcode: {},
      address: {},
      tel: {}
    };

    if (this.deliveryAddress === MANUSCRIPT_DELIVERY_ADDRESS.OTHER_ADDRESS) {
      validations = {
        ...validations,
        ...{
          name: {
            required
          },
          zipcode: {
            required,
            zipcode
          },
          address: {
            required
          },
          tel: {
            required,
            tel
          }
        }
      };
    }

    return validations;
  },

  computed: {
    deliveryAddress(): string {
      return this.productDeliveryAddress.deliveryAddress;
    },
    name(): string {
      return this.productDeliveryAddress.name;
    },
    company(): string {
      return this.productDeliveryAddress.company;
    },
    zipcode(): string {
      return this.productDeliveryAddress.zipcode;
    },
    address(): string {
      return this.productDeliveryAddress.address;
    },
    tel(): string {
      return this.productDeliveryAddress.tel;
    },
    MANUSCRIPT_DELIVERY_ADDRESS(): DeliveryAddressStringInterface {
      return MANUSCRIPT_DELIVERY_ADDRESS;
    },
    isOtherContactAreaShow(): boolean {
      return otherContactAresShow(this.deliveryAddress);
    },
    isStoreContactAreaShow(): boolean {
      return storeContactAresShow(this.deliveryAddress);
    }
  },

  methods: {
    validation(label: string): boolean {
      if (!label) {
        this.$v.$touch();
      } else {
        this.$v[label].$touch();
      }
      return !this.$v.$invalid;
    },

    updateProductDeliveryAddress(label: string, value: string): void {
      this.validation(label);
      this.$emit(
        "updateProductDeliveryAddress",
        Object.assign({}, this.productDeliveryAddress, { [label]: value }),
        label
      );
    },

    autocomplete(): void {
      if (this.zipcode.length >= 7) {
        YubinBango.getAddress(this.zipcode).then(res => {
          let address = res.prefecture + res.locality + res.street;
          if (res.extended) {
            address = address + res.extended;
          }
          this.updateProductDeliveryAddress("address", address);
        });
      }
    },

    copyFromDescription(): void {
      this.validation("");
      this.$emit(
        "updateProductDeliveryAddress",
        Object.assign({}, this.productDeliveryAddress, {
          name: this.descriptionName,
          company: this.descriptionCompany,
          zipcode: this.descriptionZipcode,
          address: this.descriptionAddress,
          tel: this.descriptionTel
        }),
        ""
      );
    },

    openModalBtnClick(): void {
      this.$emit("openModalBtnClick");
    },

    zenkakuToHankaku
  },

  watch: {
    deliveryAddress: function(newValue: string, oldValue: string): void {
      if (oldValue === "") {
        this.copyFromDescription();
      }
    }
  }
});
